<div class="flex items-center justify-center min-h-screen">
  <div class=" p-8 text-center max-w-md">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-24 w-24 mx-auto text-red-600 mb-4 animate-jump animate-infinite" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M5.636 5.636a9 9 0 0112.728 0 9 9 0 010 12.728 9 9 0 01-12.728 0 9 9 0 010-12.728z" />
    </svg>
    <h1 class="text-3xl text-black mb-2">{{'error-acceso' | translate}}</h1>
    <p class="text-gray-600 mb-6">{{'text-error-acceso'| translate}}</p>
    <button routerLink="/" class="px-6 py-2 bg-azul text-white rounded-lg hover:text-blue-300 duration-1000">
      {{'volver-inicio' | translate}}
    </button>
  </div>
</div>
